/* ELEMENTS */
  const urlParams = new URLSearchParams(window.location.search);
  const materialName = urlParams.get('material_name');

  const radios = document.querySelectorAll('input[name="layout"]');

  const wallAFeet = document.getElementById('wallAFeet');
  const wallAInch = document.getElementById('wallAInch');

  const wallBFeet = document.getElementById('wallBFeet');
  const wallBInch = document.getElementById('wallBInch');

  const wallCFeet = document.getElementById('wallCFeet');
  const wallCInch = document.getElementById('wallCInch');

  const wallBRow = document.getElementById('wallBRow');
  const wallCRow = document.getElementById('wallCRow');

  const layoutType = document.getElementById('layoutType');
  const layoutTypeTitle = document.getElementById('layoutTypeTitle');
  const layoutSize = document.getElementById('layoutSize');
  const totalPrice = document.getElementById('totalPrice');


const wallALabel = document.querySelector('.wall-a');
const wallBLabel = document.querySelector('.wall-b');
const wallCLabel = document.querySelector('.wall-c');

const wallASize = document.getElementById('wallASize');
const wallBSize = document.getElementById('wallBSize');
const wallCSize = document.getElementById('wallCSize');

const layoutSizeDisplay = document.getElementById('layoutSizeDisplay');

const measurementLayoutImage =
document.getElementById('measurementLayoutImage');

const layoutPreview =
document.getElementById('layoutPreview');

/* SETTINGS */

const settings = window.kitchenCalculatorSettings || {};

const MULTIPLIER = Number(settings.multiplier);

const MATERIAL_PRICES = {
  'PU Finish': Number(settings.puFinishPrice),
  'Wooden Finish': Number(settings.woodenFinishPrice),
  'Acrylic Finish': Number(settings.acrylicFinishPrice),
  'Laminate Finish': Number(settings.laminateFinishPrice)
};

/* CONVERT FEET + INCH */

  function convertToFeet(feet, inch) {
    return parseFloat(feet) + parseFloat(inch) / 12;
  }

/* RESET VALUES */

  function resetValues(layout) {
    // Default reset values
    wallAFeet.value = 0;
    wallAInch.value = 0;

    wallBFeet.value = 0;
    wallBInch.value = 0;

    wallCFeet.value = 0;
    wallCInch.value = 0;

    // SHOW / HIDE WALLS
    if (layout === 'S' || layout === 'I') {

  wallBRow.classList.add('hidden');
  wallCRow.classList.add('hidden');

}
else if (layout === 'U') {

  wallBRow.classList.remove('hidden');
  wallCRow.classList.remove('hidden');

}
else {

  wallBRow.classList.remove('hidden');
  wallCRow.classList.add('hidden');

}
  }

/* CALCULATE PRICE */

  function calculatePrice() {
    const PRICE_PER_FEET =
    MATERIAL_PRICES[materialName] ||
    MATERIAL_PRICES['Laminate Finish']; // default

  const selectedLayout =
    document.querySelector('input[name="layout"]:checked');

  if (!selectedLayout) return;

  const layout = selectedLayout.value;

  const a = convertToFeet(
    wallAFeet.value,
    wallAInch.value
  );

  const b = convertToFeet(
    wallBFeet.value,
    wallBInch.value
  );

  const c = convertToFeet(
    wallCFeet.value,
    wallCInch.value
  );

  let totalFeet = 0;
  let layoutName = '';
  let sizeText = '';

  /* RESET LABELS */

  if (wallALabel) wallALabel.style.display = 'none';
  if (wallBLabel) wallBLabel.style.display = 'none';
  if (wallCLabel) wallCLabel.style.display = 'none';

  if (wallASize) wallASize.textContent = '';
  if (wallBSize) wallBSize.textContent = '';
  if (wallCSize) wallCSize.textContent = '';

  /* L SHAPE */

  if (layout === 'L') {

    totalFeet = a + b;

    layoutName = 'L Shaped Design';

    sizeText =
      `${wallAFeet.value}' ${wallAInch.value}" x ${wallBFeet.value}' ${wallBInch.value}"`;

    if (wallALabel) wallALabel.style.display = 'block';
    if (wallBLabel) wallBLabel.style.display = 'block';

    if (wallASize) {
      wallASize.textContent =
        `${wallAFeet.value}' ${wallAInch.value}"`;
    }

    if (wallBSize) {
      wallBSize.textContent =
        `${wallBFeet.value}' ${wallBInch.value}"`;
    }
  }

  /* U SHAPE */

  else if (layout === 'U') {

    totalFeet = a + b + c;

    layoutName = 'U Shaped Design';

    sizeText =
      `${wallAFeet.value}' ${wallAInch.value}" x ${wallBFeet.value}' ${wallBInch.value}" x ${wallCFeet.value}' ${wallCInch.value}"`;

    if (wallALabel) wallALabel.style.display = 'block';
    if (wallBLabel) wallBLabel.style.display = 'block';
    if (wallCLabel) wallCLabel.style.display = 'block';

    if (wallASize) {
      wallASize.textContent =
        `${wallAFeet.value}' ${wallAInch.value}"`;
    }

    if (wallBSize) {
      wallBSize.textContent =
        `${wallBFeet.value}' ${wallBInch.value}"`;
    }

    if (wallCSize) {
      wallCSize.textContent =
        `${wallCFeet.value}' ${wallCInch.value}"`;
    }
  }

  /* PARALLEL */

  else if (layout === 'P') {

    totalFeet = a + b;

    layoutName = 'Parallel Design';

    sizeText =
      `${wallAFeet.value}' ${wallAInch.value}" x ${wallBFeet.value}' ${wallBInch.value}"`;

    if (wallALabel) wallALabel.style.display = 'block';
    if (wallBLabel) wallBLabel.style.display = 'block';

    if (wallASize) {
      wallASize.textContent =
        `${wallAFeet.value}' ${wallAInch.value}"`;
    }

    if (wallBSize) {
      wallBSize.textContent =
        `${wallBFeet.value}' ${wallBInch.value}"`;
    }
  }

  /* STRAIGHT */

  else if (layout === 'S') {

    totalFeet = a;

    layoutName = 'Straight Design';

    sizeText =
      `${wallAFeet.value}' ${wallAInch.value}"`;

    if (wallALabel) wallALabel.style.display = 'block';

    if (wallASize) {
      wallASize.textContent =
        `${wallAFeet.value}' ${wallAInch.value}"`;
    }
  }

    /* ISLAND */
else if (layout === 'I') {
  totalFeet = a;
  layoutName = 'Island Design';
  sizeText =
    `${wallAFeet.value}' ${wallAInch.value}"`;

  if (wallALabel) wallALabel.style.display = 'block';

  if (wallASize) {
    wallASize.textContent =
      `${wallAFeet.value}' ${wallAInch.value}"`;
  }
}

/* Peninsula */
else if (layout === 'N') {

  totalFeet = a + b;

  layoutName = 'Peninsula Design';

  sizeText =
    `${wallAFeet.value}' ${wallAInch.value}" x ${wallBFeet.value}' ${wallBInch.value}"`;

  if (wallALabel) wallALabel.style.display = 'block';
  if (wallBLabel) wallBLabel.style.display = 'block';

  if (wallASize) {
    wallASize.textContent =
      `${wallAFeet.value}' ${wallAInch.value}"`;
  }

  if (wallBSize) {
    wallBSize.textContent =
      `${wallBFeet.value}' ${wallBInch.value}"`;
  }
}

  /* PRICE */

  const total = Math.round(
  totalFeet *
  MULTIPLIER *
  PRICE_PER_FEET
);

  /* UPDATE UI */

  if (layoutType) {
    layoutType.innerText = layoutName;
  }
    if (layoutTypeTitle) {
    layoutTypeTitle.innerText = layoutName;
  }

  
  if (layoutSize) {
    layoutSize.innerText = sizeText;
  }

  if (layoutSizeDisplay) {
    layoutSizeDisplay.innerText = sizeText;
  }

  if (totalPrice) {
    totalPrice.innerText =
      '₹' + total.toLocaleString('en-IN');
  }

  const totalBox =
    document.querySelector('.total');

  if (totalBox) {
    totalBox.classList.add('show-total');
  }
}

/* LAYOUT CHANGE */

  radios.forEach((radio) => {

  radio.addEventListener('change', function () {

    document.querySelectorAll('.layout-card')
      .forEach(card => card.classList.remove('active'));

    this.closest('.layout-card')
      .classList.add('active');

    const imageUrl =
  this.dataset.layoutImage;

console.log(this);
console.log(imageUrl);

    if (
      measurementLayoutImage &&
      imageUrl
    ) {
      measurementLayoutImage.src = imageUrl;
    }
    /* CHANGE LAYOUT CLASS */

if (layoutPreview) {

  layoutPreview.classList.remove(
  'layout-l',
  'layout-u',
  'layout-p',
  'layout-s',
  'layout-i',
  'layout-n'
);

  layoutPreview.classList.add(
    'layout-' + this.value.toLowerCase()
  );
}

    resetValues(this.value);
    calculatePrice();
  });

});

const firstRadio =
  document.querySelector('input[name="layout"]');

if (firstRadio) {

  firstRadio.checked = true;

  firstRadio.closest('.layout-card')
    .classList.add('active');

  const imageUrl =
    firstRadio.dataset.layoutImage;

  if (
    measurementLayoutImage &&
    imageUrl
  ) {
    measurementLayoutImage.src = imageUrl;
  }

  if (layoutPreview) {

    layoutPreview.classList.remove(
      'layout-l',
      'layout-u',
      'layout-p',
      'layout-s'
    );

    layoutPreview.classList.add(
      'layout-' + firstRadio.value.toLowerCase()
    );
  }

  resetValues(firstRadio.value);
  calculatePrice();
}

  /* SELECT CHANGE */

  document.querySelectorAll('select').forEach((select) => {
    select.addEventListener('change', calculatePrice);
  });

  /* INITIAL LOAD */

document.addEventListener('DOMContentLoaded', function () {
  const layoutCards = document.querySelectorAll('.layout-card');
  const measurementSection = document.querySelector('.measurement-section');
  const headerOffset = 100; // adjust according to your sticky header height

  if (measurementSection) {
    layoutCards.forEach(card => {
      card.addEventListener('click', function () {
        setTimeout(() => {
          const elementPosition = measurementSection.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      });
    });
  }
});

const selectedMaterial =
  document.getElementById('selectedMaterial');

if (selectedMaterial && materialName) {
  selectedMaterial.textContent = materialName;
}